module.exports = __webpack_public_path__ + "img/solaris-barres-0.079c2296.png";